import { defineStyleConfig } from '@chakra-ui/react';

export default defineStyleConfig({
  baseStyle: {
    color: 'headingFontColor',
    textTransform: 'uppercase',
    _dark: {
      color: 'darkHeadingFontColor',
    },
  },
});
